import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { getSessionId } from "../../../utils/tokenHandlers";
import { getApplicationStage } from "../../../feature/apis/listOfValues/getApplicationStage";
import { getRmName } from "../../../feature/apis/listOfValues/getRmName";
import { getAllRmNames } from "../../../feature/apis/listOfValues/getAllRMNames";

interface RmNameprops {
  name: string;
  label: string;
  register: any;
  required?: boolean;
  requiredMessage?: string;
  handleChange?: () => JSX.Element;
  defaultValue?: string;
  error?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

interface RmNameData {
  id: string | number | readonly string[] | undefined;
  name: string | number | readonly string[] | undefined;
  sr_no: number;
  lov_type: string;
  lov_display_value: string;
  lov_value: string;
  is_active: boolean;
}

const RmNameType: React.FC<RmNameprops> = ({
  name,
  label,
  register,
  required,
  requiredMessage = "This field is required",
  handleChange,
  defaultValue,
  disabled,
  error,
  onChange,
}) => {
  const token = getSessionId();

  const [RmNameValues, setRmNameValues] = useState<RmNameData[]>([]);

  useEffect(() => {
    getAllRmNames(token).then((response: any) => {
      //  // console.log("application Stage --> ", response);
      setRmNameValues(response.result.result);
    });
  }, []);

  return (
    <Form.Group as={Col} className="mb-3">
      <Row className="align-items-center">
        <Form.Label column md={4}>
          <span className="float-end">
            {label}
            <span className="text-danger form-label">
              {required ? "*" : ""}
            </span>{" "}
            :
          </span>
        </Form.Label>
        <Col md={8}>
          <Form.Select
            as="select"
            className={`custom-input form-control ${error ? "is-invalid" : ""}`}
            onChange={handleChange}
            {...register(name, {
              required: required ? requiredMessage : false,
            })}
            defaultValue={defaultValue}
            disabled={disabled}
          >
            <option value="">Select Option</option>
            {RmNameValues.map((RmNameValues, index) => (
              <option key={index} value={RmNameValues.id}>
                {RmNameValues.name}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col md={4}></Col>
        <Col md={8}>{error && <p className="m-0 err-msg">{error}</p>}</Col>
      </Row>
    </Form.Group>
  );
};

export default RmNameType;
